const USAGE_DETAIL_KEYS = {
    frequency90Day: 'frequency90Day',
    frequency6Month: 'frequency6Month',
    matchPercentageYTD: 'matchPercentageYTD',
    frequencyYTD: 'frequencyYTD',
    frequencyPreviousYTD: 'frequencyPreviousYTD',
    yoyChangePercentage: 'yoyChangePercentage',
    prevFrequency1Year: 'prevFrequency1Year',
    prevFrequency2Year: 'prevFrequency2Year',
    prevFrequency3Year: 'prevFrequency3Year',
};

const compareStrings = (first, second, direction) => {
    if (first < second) return direction === 'asc' ? -1 : 1;
    if (first > second) return direction === 'asc' ? 1 : -1;
    return 0;
};

const compareNumbers = (first, second, direction) =>
    direction === 'asc' ? first - second : second - first;

const getUsageDetailValue = (code, codeUsageStatsMap, selectedUsageDetailKey) => {
    const resolvedKey = USAGE_DETAIL_KEYS[selectedUsageDetailKey] || 'frequency6Month';
    const stats = codeUsageStatsMap?.get(code.sourceCodeId);
    return stats?.[resolvedKey] ?? 0;
};

export const compareCodes = (
    firstCode,
    secondCode,
    sortField,
    sortDirection,
    codeUsageStatsMap,
    selectedUsageDetailKey
) => {
    switch (sortField) {
        case 'codeCategory':
            return compareStrings(
                (firstCode.codeCategory ?? '').toLowerCase(),
                (secondCode.codeCategory ?? '').toLowerCase(),
                sortDirection
            );

        case 'code':
            return compareStrings(
                (firstCode.code ?? '').toLowerCase(),
                (secondCode.code ?? '').toLowerCase(),
                sortDirection
            );

        case 'codeDescription':
            return compareStrings(
                (firstCode.codeDescription ?? '').toLowerCase(),
                (secondCode.codeDescription ?? '').toLowerCase(),
                sortDirection
            );

        case 'codePrice':
            return compareNumbers(firstCode.codePrice ?? 0, secondCode.codePrice ?? 0, sortDirection);

        case 'locationId':
            return compareStrings(
                (firstCode.locationId ?? '').toLowerCase(),
                (secondCode.locationId ?? '').toLowerCase(),
                sortDirection
            );

        case 'codeTTM':
            return compareNumbers(firstCode.codeTTM ?? 0, secondCode.codeTTM ?? 0, sortDirection);

        case 'usageDetails': {
            const firstValue = getUsageDetailValue(firstCode, codeUsageStatsMap, selectedUsageDetailKey);
            const secondValue = getUsageDetailValue(secondCode, codeUsageStatsMap, selectedUsageDetailKey);
            return compareNumbers(firstValue, secondValue, sortDirection);
        }

        case 'mappings': {
            const firstLabel = (firstCode.mappings?.[0]?.taxonomyCodeNodeLabel ?? '').toLowerCase();
            const secondLabel = (secondCode.mappings?.[0]?.taxonomyCodeNodeLabel ?? '').toLowerCase();
            return compareStrings(firstLabel, secondLabel, sortDirection);
        }

        case 'isBundleParent':
            return compareNumbers(
                firstCode.isBundleParent ? 1 : 0,
                secondCode.isBundleParent ? 1 : 0,
                sortDirection
            );

        default:
            return 0;
    }
};
